module.exports = "/_next/static/images/indomart_ic-9f55b6815569692b4c6d88885ec27fd7.svg";